import { ChartTileComponent } from "src/app/board/pages/board-home/board-tiles/chart-tile/chart-tile.component";
import { HeroTileComponent } from "src/app/board/pages/board-home/board-tiles/hero-tile/hero-tile.component";
import { TableTileComponent } from "src/app/board/pages/board-home/board-tiles/table-tile/table-tile.component";
import { PieTileComponent } from "src/app/board/pages/board-home/board-tiles/pie-tile/pie-tile.component";

export class IUserBoardComponent<T = any> {
  component: any; // Could be more strictly typed with generics or unions
  data: any; //IUserBoardInput
  mode: UserBoardComponentMode;
  // createComponent(): IUserBoardComponent<T>;
}


export enum UserBoardComponentMode {
  Live = 'live',
  Preview = 'preview',
  Edit = 'edit'
}

// Main layout tile
export class UserBoardItem {
  cols: number;
  rows: number;
  x: number;
  y: number;
  id: string;
  componentType: UserBoardComponentTypes
  data: IUserBoardComponent;
}

// Main layout tile
export class UserBoard {
  userBoardId: string; //guid
  filterBarId: string; //guid
  userBoardName: string;
  userBoardDescription: string;
  boardType: UserBoardTypes;
  isShared: boolean;
  isDefault: boolean;
  sharedTo: string[]; // List of user IDs or emails that the board is shared with
  createdDate: string;
  modifiedDate: string;
  createdBy: string;
  modifiedBy: string;
  itemList: UserBoardItem[]; // For tile boards
  spreadsheetData?: any; // For spreadsheet boards
}

export function convertUserBoardModelToDto(inputBoard: UserBoard): UserBoardDto {

  var dto = new UserBoardDto();
  dto.userBoardId = inputBoard.userBoardId;
  dto.filterBarId = inputBoard.filterBarId;
  dto.userBoardName = inputBoard.userBoardName;
  dto.userBoardDescription = inputBoard.userBoardDescription;
  dto.boardType = inputBoard.boardType || UserBoardTypes.TileBoard; // Default to TileBoard for legacy compatibility
  dto.isShared = inputBoard.isShared;
  dto.isDefault = inputBoard.isDefault;
  dto.sharedTo = inputBoard.sharedTo || [];
  dto.createdDate = inputBoard.createdDate;
  dto.modifiedDate = inputBoard.modifiedDate;
  dto.createdBy = inputBoard.createdBy;
  dto.modifiedBy = inputBoard.modifiedBy;
  
  // Handle different board types
  if (dto.boardType === UserBoardTypes.SpreadsheetBoard) {
    // For spreadsheet boards, copy spreadsheet data
    dto.spreadsheetData = inputBoard.spreadsheetData;
    dto.itemList = []; // Empty for spreadsheet boards
  } else {
    // For tile boards, process itemList
    dto.itemList = (inputBoard.itemList || []).map(item => {
      var itemDto = new UserBoardItemDto();
      itemDto.cols = item.cols;
      itemDto.rows = item.rows;
      itemDto.x = item.x;
      itemDto.y = item.y;
      itemDto.id = item.id;
      itemDto.componentType = item.componentType;
      itemDto.data = new UserBoardComponentDto();
      itemDto.data.data = item.data?.data; // Safe access with optional chaining
      return itemDto;
    });
    dto.spreadsheetData = null; // Empty for tile boards
  }
  
  return dto;
}

export class UserBoardsDto {
  userBoards: UserBoardDto[];
}

export class UserBoardDto {
  userBoardId: string; //guid
  filterBarId: string; //guid
  userBoardName: string;
  userBoardDescription: string;
  boardType: UserBoardTypes;
  isShared: boolean;
  isDefault: boolean;
  sharedTo: string[]; // List of user IDs or emails that the board is shared with
  createdDate: string;
  modifiedDate: string;
  createdBy: string;
  modifiedBy: string;
  itemList: UserBoardItemDto[]; // For tile boards
  spreadsheetData?: any; // For spreadsheet boards
}

export function convertUserBoardDtoToModel(inputBoard: UserBoardDto, mode: UserBoardComponentMode): UserBoard {
  var model = new UserBoard();
  model.userBoardId = inputBoard.userBoardId;
  model.filterBarId = inputBoard.filterBarId;
  model.userBoardName = inputBoard.userBoardName;
  model.userBoardDescription = inputBoard.userBoardDescription;
  model.boardType = inputBoard.boardType || UserBoardTypes.TileBoard; // Default to TileBoard for legacy compatibility
  model.isShared = inputBoard.isShared;
  model.isDefault = inputBoard.isDefault;
  model.sharedTo = inputBoard.sharedTo || [];
  model.createdDate = inputBoard.createdDate;
  model.modifiedDate = inputBoard.modifiedDate;
  model.createdBy = inputBoard.createdBy;
  model.modifiedBy = inputBoard.modifiedBy;
  
  // Handle different board types
  if (model.boardType === UserBoardTypes.SpreadsheetBoard) {
    // For spreadsheet boards, copy spreadsheet data
    model.spreadsheetData = inputBoard.spreadsheetData;
    model.itemList = []; // Empty for spreadsheet boards
  } else {
    // For tile boards, process itemList
    model.itemList = (inputBoard.itemList || []).map(item => {
      var itemModel = new UserBoardItem();
      itemModel.cols = item.cols;
      itemModel.rows = item.rows;
      itemModel.x = item.x;
      itemModel.y = item.y;
      itemModel.id = item.id;
      itemModel.componentType = item.componentType;
      switch (item.componentType) {
        case UserBoardComponentTypes.heroTile:
            itemModel.data = {component: null, data: item.data?.data, mode: mode};
          break;
        case UserBoardComponentTypes.pieChartTile:
            itemModel.data = {component: null, data: item.data?.data, mode: mode};
          break;
        // Add other cases for different component types here
        default:
            itemModel.data = {component: null, data: item.data?.data, mode: mode};
      };
      return itemModel;
    });
    model.spreadsheetData = null; // Empty for tile boards
  }
  
  return model;
}

export function AddComponentToUserBoardItem(item: UserBoardItem): UserBoardItem {
  switch (item.componentType) {
    case UserBoardComponentTypes.heroTile:
      item.data.component = HeroTileComponent;
      break;
    case UserBoardComponentTypes.chartTile:
      item.data.component = ChartTileComponent;
      break;
    case UserBoardComponentTypes.tableTile:
      item.data.component = TableTileComponent;
      break;
    case UserBoardComponentTypes.pieChartTile:
      item.data.component = PieTileComponent;
      break;
    // Add other cases for different component types here
    default:
      item.data.component = HeroTileComponent;
  };
  return item;
}

export class UserBoardItemDto {
  cols: number;
  rows: number;
  x: number;
  y: number;
  id: string;
  componentType: UserBoardComponentTypes
  data: UserBoardComponentDto;
}

export class UserBoardComponentDto {
  data: any;
}

export enum UserBoardTypes {
  TileBoard = 'tileBoard',
  SpreadsheetBoard = 'spreadsheetBoard'
}

export enum UserBoardComponentTypes {
  heroTile = 'heroTile',
  pieChartTile = 'pieChartTile',
  chartTile = 'chartTile',
  tableTile = 'tableTile',
  textTile = 'textTile',
  imageTile = 'imageTile',
  videoTile = 'videoTile',
}

